document.addEventListener("DOMContentLoaded", () => {
  // footer M端 导航
  const isMobileFooter = () => window.matchMedia("(max-width: 1000px)").matches;

  const getFooterContent = (button) => button.closest(".footer-menu").find(".footer-menu-content");

  const updateFooterToggleA11y = (button, expanded) => {
    const content = getFooterContent(button);
    if (isMobileFooter()) {
      button.attr("aria-expanded", expanded ? "true" : "false");
      content.attr("aria-hidden", expanded ? "false" : "true");
      return;
    }

    button.attr("aria-expanded", "true");
    content.removeAttr("aria-hidden");
  };

  $(".footer-menu-title__button").each(function () {
    updateFooterToggleA11y($(this), false);
  });

  $(".footer-menu-title__button").click(function () {
    const currentButton = $(this);
    const isExpanded = currentButton.attr("aria-expanded") === "true";

    if (isMobileFooter()) {
      const otherButtons = $(".footer-menu-title__button").not(currentButton);
      otherButtons.each(function () {
        const button = $(this);
        updateFooterToggleA11y(button, false);
        button.find(".footer-menu-title__toggle").removeClass("icon-rotate");
        getFooterContent(button).slideUp();
      });
    }

    getFooterContent(currentButton).slideToggle();

    const toggle = currentButton.find(".footer-menu-title__toggle");
    if (toggle.hasClass("icon-rotate")) {
      toggle.removeClass("icon-rotate");
    } else {
      toggle.addClass("icon-rotate");
    }

    updateFooterToggleA11y(currentButton, !isExpanded);
  });

  $(".footer-menu-title").click(function () {
    if (!isMobileFooter()) {
      return;
    }
    $(this).closest(".footer-menu-title-row").find(".footer-menu-title__button").trigger("click");
  });
  // footer M端 导航


  // 底部返回页面顶部按钮
  $("#back-top-button").hide();

  $(window).scroll(function () {
    if ($(window).scrollTop() > 500) {
      $("#back-top-button").fadeIn();
    } else {
      $("#back-top-button").fadeOut();
    }
  });

  $("#back-top-button").click(function () {
    $("html,body").animate({ scrollTop: 0 }, 1000);
  })
  // 底部返回页面顶部按钮

});
